export const getFAQsTagsAPI = "/faqs/categories";
export const getFAQsAPI = "/faqs";
export function getFAQAPI(id){ return "/faqs/"+id;} 
export const createFAQsAPI = "/faqs";
export function deleteFAQAPI(id){ return "/faqs/"+id;} 
export function editFAQAPI(id){ return "/faqs/"+id;} 